import styled from "@emotion/styled";

import { DesignToken, Heading, ShadowToken, SpacingToken } from "@livechat/design-system-react-components";

import { Icon } from "components/icon";
import { withVar } from "themes/helpers";

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;
`;

export const StyledWrapper = styled.div`
  max-width: 880px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background: ${withVar(DesignToken.SurfacePrimaryDefault)};
  font-size: 14px;
`;

export const StyledSectionTitle = styled(Heading)`
  display: flex;
  flex-direction: row;
  padding-bottom: 6px;
  margin-bottom: var(${SpacingToken.Spacing4});
  box-shadow: var(${ShadowToken.DividerBottom});
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  gap: ${withVar(SpacingToken.Spacing1)};
`;

export const StyledSectionText = styled.div`
  margin: 0 0 10px 10px;
`;

export const StyledErrorIcon = styled(Icon)`
  fill: ${withVar(DesignToken.ContentBasicNegative)};
  display: flex;
  align-self: center;
`;

export const StyledEditInvoiceEmailWrapper = styled.div`
  margin: 0 0 18px 10px;
`;
